import { render } from "./ProjectLanguageDropdown.vue?vue&type=template&id=6d90fea0"
import script from "./ProjectLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectLanguageDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__